// Data Model
import Model from "./Model";
import {each, isObject} from "lodash";

const model =
    {
        _list: [],

        add: function add(name,options)
        {
            this[name] = new Model(name, options); // store at top level so we ca write model.<item>
            this._list.push(name);
            return this[name];
        },

        emptyAll: function emptyAll()
        {
            var me = this;
            each(this._list, function(key){
                me[key].empty();
            });
        }
    };

model.add('account');
model.add('advertiser');
model.add('salesSheet');
model.add('specAd');
model.add('managedFile');
model.add('person');
//model.add('trial');
//model.add('contact');  // Used to keep local device contacts (orgs and/or people)
model.add('project');    // minimal list of project info
model.add('fullProject', { // full projects with projects items,  shares etc
    compareFields: ['recordVersion','itemCount']   // TBD ?roles canPerforms
});
model.add('projectItem');
model.add('order');

//NOTE override for compound key as share can person or account (maybe team)
function getShareKey(record)
{
    if (isObject(record) && 'sourceId' in record  && 'sourceType' in record)
        //Note ignores target
        return record.sourceType + '_' + record.sourceId;
}
model.add('share',
    {
        compareFields: ['userPrivilege'],  // Nothing else can change
        'getKey': getShareKey
    });
model.add('editShare',
    {
        'cloneOnStore': true,
        compareFields: ['userPrivilege'],  // Nothing else can change
        'getKey': getShareKey
    });

//model.add('role');
model.add('history',
    {
        compareFields: ['id','isSelected'] //trigger redraw whenwe switch to group by
    });



// mcc model stuff...
model.add('asset',{
    key: 'file_name'
});


export default model;
